module.exports = __webpack_public_path__ + "static/media/y1054.99e7059d.wav";